import { useTranslation } from "next-i18next";
import { sharedServerSideProps } from "@/src/utils/sharedServerSideProps";
import { ContentType } from "@/src/utils/enum";
import { Article } from "@/lib/types/Article";
import { Opinion } from "@/lib/types/Opinion";
import { Document } from "@/lib/types/Document";
import Footer from "@/src/shared/Footer";
import Header from "@/src/shared/Header/Header";
import MobileMenu from "@/src/shared/Header/subs/MainHeader/MobileMenu";
import PageHead from "@/src/shared/PageHead";
import BackToTop from "@/src/shared/BackToTop";
import AboutUsPage from "@/src/features/about-us/AboutUsPage";
import AboutUsPageContext, { IAboutUsPageContext } from "@/src/features/about-us/AboutUsPageContext";
import API from "@/lib/api";

export default function AboutUs({ page }: { page: IAboutUsPageContext }) {
  const { t } = useTranslation();

  return (
    <AboutUsPageContext.Provider value={page}>
      <PageHead title={t("aboutUs")} />
      <Header />
      <MobileMenu />
      <AboutUsPage />
      <BackToTop />
      <Footer />
    </AboutUsPageContext.Provider>
  );
}

export const getServerSideProps = sharedServerSideProps(async () => {
  const [articles, opinions] = await Promise.all([
    API.Client.get<Article[]>("/api/article/list", {
      params: {
        Skip: 0,
        Take: 3,
        "Filters[ContentType]": `${ContentType.Institutional}, ${ContentType.Vision}, ${ContentType.Mission}`
      }
    }),
    API.Client.get<Opinion[]>("/api/opinion/list", {
      params: { Skip: 0, Take: 30 }
    })
  ]);

  const institutional = articles?.find(x => x.ContentType === ContentType.Institutional);
  const vision = articles?.find(x => x.ContentType === ContentType.Vision);
  const mission = articles?.find(x => x.ContentType === ContentType.Mission);

  const documents = institutional?.IdGuid
    ? await API.Client.get<Document[]>("/api/document/list", {
        params: { Skip: 0, Take: 3, Search: institutional.IdGuid }
      })
    : [];

  return {
    page: { institutional, vision, mission, opinions, documents }
  };
});
